module.exports = __webpack_public_path__ + "static/media/illustration-register-copy@3x.05fcbc06.png";